import React, { useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/store/store";
import { setToast } from "../../../shared/store/slice/toastSlice";

const Toast: React.FC = () => {
  const dispatch = useDispatch();
  const toast: any = useSelector((state: RootState) => state.toast);

  useEffect(() => {
    if (toast.open) {
      setTimeout(() => {
        dispatch(setToast({ message: "", severity: "", open: false }));
      }, 6000);
    }
  }, [toast.open, dispatch]);

  const handleClose = () => {
    dispatch(setToast({ message: "", severity: "", open: false }));
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={toast.open}
      onClose={handleClose}
    >

      <Alert
        onClose={handleClose}
        severity={toast.severity}
        sx={{
          width: "100%",
          alignItems: "center", // ✅ Align icon and text vertically
          backgroundColor:
            toast.severity === "success"
              ? "#b5d5ff"
              : toast.severity === "error"
              ? "#fdecea"
              : toast.severity === "warning"
              ? "#fff4e5"
              : "#e3f2fd",
          color:
            toast.severity === "success"
              ? "#1b5e20"
              : toast.severity === "error"
              ? "#d32f2f"
              : toast.severity === "warning"
              ? "#ed6c02"
              : "#0288d1",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          borderRadius: "8px",
          "& .MuiAlert-icon": {
            color:
              toast.severity === "success"
                ? "#2e7d32"
                : toast.severity === "error"
                ? "#d32f2f"
                : toast.severity === "warning"
                ? "#ed6c02"
                : "#0288d1",
            marginTop: "0px", // ✅ Remove any unexpected top margin
            alignSelf: "center", // ✅ Ensure icon aligns vertically
          },
          "& .MuiAlert-message": {
            fontWeight: 500,
            display: "flex",
            alignItems: "center", // ✅ Align message text with icon
          },
        }}
        className="toast"
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
